export const firebaseConfig = {
    apiKey: "AIzaSyCMaY1ry3tg8SlEe-5t6rLP_zXTzg9bMsE",
    authDomain: "encargas-9bb02.firebaseapp.com",
    projectId: "encargas-9bb02",
    storageBucket: "encargas-9bb02.appspot.com",
    messagingSenderId: "385615642951",
    appId: "1:385615642951:web:2a6ece2670336aee4a0c62",
    measurementId: "G-8C2JXWD1PK"
};